/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as MediaRouteImport } from './routes/media'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as ServicesSlugRouteImport } from './routes/services/$slug'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'

const ResourcesRoute = ResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaRoute = MediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesIndexRoute = ServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesSlugRoute = ServicesSlugRouteImport.update({
  id: '/services/$slug',
  path: '/services/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/media': typeof MediaRoute
  '/resources': typeof ResourcesRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/services/$slug': typeof ServicesSlugRoute
  '/blog/': typeof BlogIndexRoute
  '/services/': typeof ServicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/media': typeof MediaRoute
  '/resources': typeof ResourcesRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/services/$slug': typeof ServicesSlugRoute
  '/blog': typeof BlogIndexRoute
  '/services': typeof ServicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/media': typeof MediaRoute
  '/resources': typeof ResourcesRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/services/$slug': typeof ServicesSlugRoute
  '/blog/': typeof BlogIndexRoute
  '/services/': typeof ServicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/media'
    | '/resources'
    | '/blog/$slug'
    | '/services/$slug'
    | '/blog/'
    | '/services/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/media'
    | '/resources'
    | '/blog/$slug'
    | '/services/$slug'
    | '/blog'
    | '/services'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/contact'
    | '/media'
    | '/resources'
    | '/blog/$slug'
    | '/services/$slug'
    | '/blog/'
    | '/services/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  MediaRoute: typeof MediaRoute
  ResourcesRoute: typeof ResourcesRoute
  BlogSlugRoute: typeof BlogSlugRoute
  ServicesSlugRoute: typeof ServicesSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
  ServicesIndexRoute: typeof ServicesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media': {
      id: '/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof MediaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/': {
      id: '/services/'
      path: '/services'
      fullPath: '/services/'
      preLoaderRoute: typeof ServicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/$slug': {
      id: '/services/$slug'
      path: '/services/$slug'
      fullPath: '/services/$slug'
      preLoaderRoute: typeof ServicesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  MediaRoute: MediaRoute,
  ResourcesRoute: ResourcesRoute,
  BlogSlugRoute: BlogSlugRoute,
  ServicesSlugRoute: ServicesSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
  ServicesIndexRoute: ServicesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
